export default __webpack_public_path__ + "static/media/ativo-16.e797ce8d.png";